import { useEffect, useRef } from "react";

/**
 * Single-key shortcuts for the triage queue. Ignores keystrokes while a text
 * field has focus, so typing a removal reason does not fire actions.
 */
export function useHotkeys(map: Record<string, () => void>) {
  // Held in a ref so the listener is bound once and never sees a stale closure.
  const mapRef = useRef(map);
  mapRef.current = map;

  useEffect(() => {
    const handler = (ev: KeyboardEvent) => {
      const el = ev.target as HTMLElement | null;
      if (el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return;
      if (el?.isContentEditable) return;
      if (ev.metaKey || ev.ctrlKey || ev.altKey) return;

      const fn = mapRef.current[ev.key.toLowerCase()];
      if (!fn) return;
      ev.preventDefault();
      fn();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);
}
